import communityDiscussionDetailPageLoad from "~/store/graphql/queries/communityDiscussionDetailPageLoad.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const loadCommunityDiscussionDetails = async function (
  { commit },
  { params, req, res }
) {
  commit("START_LOADING");

  const data = await runGraphQLQuery(
    communityDiscussionDetailPageLoad,
    params,
    this.$axios,
    req,
    res
  );

  commit("SELECT_DISCUSSION", data);

  commit("END_LOADING");

  return Promise.resolve(data);
};

export default loadCommunityDiscussionDetails;
